import { LuArrowUpRight, LuMail } from 'react-icons/lu'
import { Link } from 'react-router-dom'
import MakerDoodle from '../MakerDoodle'
import FloatingIcons from '../FloatingIcons'
import './SectionAccents.css'
import './Resume.css'

const Resume = () => {
    return (
        <section
            id="resume"
            className="connect-section section"
            aria-labelledby="connect-title"
        >
            <FloatingIcons variant="contact" />
            <div className="site-container connect-grid">
                <div className="connect-copy" data-reveal>
                    <p className="eyebrow">03 / Say hello</p>
                    <h2 id="connect-title" className="section-title">
                        Good things start with a hello.
                    </h2>
                    <p>
                        Have an idea brewing, something you're working on, or
                        just want to talk about design, technology, and all the
                        things in between? My inbox is open!
                    </p>
                    <a
                        className="button button--primary"
                        href="mailto:the.josephine.nguyen@gmail.com"
                    >
                        <LuMail aria-hidden="true" /> Get in touch{' '}
                        <LuArrowUpRight aria-hidden="true" />
                    </a>
                    <MakerDoodle
                        variant="thread"
                        className="connect-copy__doodle"
                    />
                </div>

                <div className="resume-card" data-reveal>
                    <svg
                        className="resume-card__postmark"
                        viewBox="0 0 130 60"
                        aria-hidden="true"
                        focusable="false"
                    >
                        <circle cx="91" cy="30" r="23" />
                        <circle cx="91" cy="30" r="18" />
                        <path d="M5 18c12-5 18 5 30 0s18 5 30 0M5 29c12-5 18 5 30 0s18 5 30 0M5 40c12-5 18 5 30 0s18 5 30 0" />
                    </svg>
                    <div className="resume-card__header"></div>
                    <p className="eyebrow">A little more about me</p>
                    <h3>The story so far.</h3>
                    <p>
                        A closer look at where I've been, what I've worked on,
                        and the things I've picked up along the way.
                    </p>

                    <div className="resume-card__option">
                        <h4>Resume</h4>
                        <p>
                            The short(er) version. A snapshot of my experience,
                            education, and skills.
                        </p>
                        <a
                            className="resume-card__link"
                            href={`${process.env.PUBLIC_URL}/JosephineNguyen_Resume.pdf`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            View my resume <LuArrowUpRight aria-hidden="true" />
                            <span className="sr-only">
                                {' '}
                                (PDF, opens in a new tab)
                            </span>
                        </a>
                    </div>
                    <div className="resume-card__option">
                        <h4>CV</h4>
                        <p>
                            The extended edition. A more complete look at my
                            work, projects, and professional journey.
                        </p>
                        <Link className="resume-card__link" to="/cv">
                            Explore my CV <LuArrowUpRight aria-hidden="true" />
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Resume
